<template>
  <v-container :fluid="fullWidth">
    <ContentHeader
      header-icon="mdi-group"
      header-title="Vendor Group Manager"
      back-navigation
      back-navigation-href="/admin"
      back-navigation-text="To Old Admin"
    >
    </ContentHeader>
    <v-container fluid>
      <div class="mb-4 group-loader-card">
        <div class="d-flex flex-wrap mb-2">
          <v-text-field
            label="Signup Code"
            dense
            outlined
            hide-details="auto"
            v-model="signupCode"
            :disabled="!isEmpty(covgId) || !isEmpty(covId) || !isEmpty(ptid)"
            class="mr-2"
          ></v-text-field>
          <v-text-field
            label="COVG ID"
            dense
            outlined
            hide-details="auto"
            v-model="covgId"
            :disabled="
              !isEmpty(signupCode) || !isEmpty(covId) || !isEmpty(ptid)
            "
            class="mr-2"
          ></v-text-field>
          <v-text-field
            label="COV ID"
            dense
            outlined
            hide-details="auto"
            v-model="covId"
            :disabled="
              !isEmpty(signupCode) || !isEmpty(covgId) || !isEmpty(ptid)
            "
            class="mr-2"
          ></v-text-field>
          <v-text-field
            label="PTID"
            dense
            outlined
            hide-details="auto"
            v-model="ptid"
            :disabled="
              !isEmpty(signupCode) || !isEmpty(covgId) || !isEmpty(covId)
            "
            class="mr-2"
          ></v-text-field>
          <v-spacer />
          <v-btn
            v-if="
              this.vendorGroups && this.vendorGroups.length > 0 && !regroupMode
            "
            class="mx-1"
            text
            @click="clearGroups()"
          >
            <v-icon left size="18">
              mdi-reload
            </v-icon>
            Clear Vendor Groups
          </v-btn>
          <v-btn
            outlined
            class="mx-1"
            type="submit"
            color="primary"
            @click="loadVendorGroup()"
            :loading="this.loadingGroups"
            :disabled="
              (isEmpty(this.signupCode) &&
                isEmpty(this.covgId) &&
                isEmpty(this.covId) &&
                isEmpty(this.ptid)) ||
                this.loadingGroups
            "
          >
            <v-icon left size="18">
              mdi-download-box-outline
            </v-icon>
            Load Vendor Group
          </v-btn>
        </div>
        <div class="body-1 mb-4">
          Load a vendor group by its Signup Code, COVG ID, COV ID, or PTID. If
          using a COV ID, the entire group that contains that COV will be
          loaded.
        </div>
        <div
          class="d-flex flex-wrap mb-2"
          v-if="this.vendorGroups && this.vendorGroups.length > 0"
        >
          <v-btn text v-if="fullWidth" @click="fullWidth = false">
            <v-icon>mdi-arrow-collapse-horizontal</v-icon>
          </v-btn>
          <v-btn text v-else @click="fullWidth = true">
            <v-icon>mdi-arrow-expand-horizontal</v-icon>
          </v-btn>
          <v-btn
            text
            v-if="showLinkedVendors"
            @click="showLinkedVendors = false"
          >
            Hide Linked Vendors
          </v-btn>
          <v-btn text v-else @click="showLinkedVendors = true">
            Show Linked Vendors
          </v-btn>
          <v-spacer />
          <v-btn
            outlined
            class="mx-1"
            v-if="!regroupMode"
            color="primary"
            @click="enableRegrouping()"
          >
            <v-icon left size="18">
              mdi-ungroup
            </v-icon>
            Regroup
          </v-btn>
          <v-btn
            text
            class="mx-1"
            v-if="regroupMode"
            @click="cancelRegrouper()"
          >
            <v-icon left size="18">
              mdi-vector-square-remove
            </v-icon>
            Cancel Regrouping
          </v-btn>
          <v-btn
            outlined
            class="mx-1"
            v-if="regroupMode"
            color="primary"
            @click="addNewGroup()"
          >
            <v-icon left size="18">
              mdi-vector-square-plus
            </v-icon>
            New Group
          </v-btn>
          <v-btn
            class="mx-1"
            v-if="regroupMode"
            color="primary"
            @click="confirmationDialogOpen = true"
          >
            <v-icon left size="18">
              mdi-check
            </v-icon>
            Save Changes
          </v-btn>
        </div>
      </div>

      <draggable :list="vendorGroups" v-bind="dragOptions" group="vendorGroups">
        <v-hover
          v-slot="{ hover }"
          v-for="covg in vendorGroups"
          :key="covg.preferredName + covg.id"
          class="movable"
        >
          <ClientOwnedVendorGroup
            :covg="covg"
            :drag="regroupMode && regroupAllowed(covg)"
            :show-vendor="showLinkedVendors"
            class="mb-4"
            :class="{
              noregroup: regroupMode && !regroupAllowed(covg)
            }"
          >
            <v-fab-transition>
              <v-btn
                v-show="!regroupMode && hover"
                @click="remove(vendorGroups, covg)"
                class="mr-n10"
                fab
                absolute
                top
                right
                small
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-fab-transition>
          </ClientOwnedVendorGroup>
        </v-hover>
      </draggable>
    </v-container>

    <v-dialog v-model="confirmationDialogOpen" width="600">
      <v-card class="py-4">
        <v-card-text>
          Note that some COVs may not be able to be moved. After you click
          'Confirm Changes', we will attempt to regroup accordingly. A
          notification will indicate the IDs of any COVs that we were unable to
          move, and the page will update to show the actual result of the
          regrouping.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelRegroup">
            Cancel
          </v-btn>
          <v-btn color="primary" @click="confirmRegroup">
            <v-icon left size="18">
              mdi-check-underline
            </v-icon>
            Confirm Changes
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="regroupingOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { get, post } from "@/services/request";
import {
  covgBySignupCodeAPI,
  covgByIdAPI,
  covgByCovIdAPI,
  covgByPtidAPI,
  regroupCovgsAPI,
  currentClientAPI
} from "@/services/api";
import ClientOwnedVendorGroup from "@/views/admin/ClientOwnedVendorGroup.vue";
import cloneDeep from "lodash/cloneDeep";
import hasNotifications from "@/mixins/has-notifications";
import draggable from "vuedraggable";
import ContentHeader from "@/views/ContentHeader.vue";

export default {
  name: "VendorGroupManager",
  components: { ContentHeader, ClientOwnedVendorGroup, draggable },
  mixins: [hasNotifications],
  computed: {
    dragOptions() {
      return {
        animation: 400,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  data() {
    return {
      signupCode: null,
      covgId: null,
      covId: null,
      ptid: null,
      regroupMode: false,
      vendorGroups: [],
      vendorGroupsRestorePoint: [],
      newGroupNumber: 1,
      confirmationDialogOpen: false,
      loadingGroups: false,
      selectedClient: null,
      regroupingOverlay: false,
      fullWidth: false,
      showLinkedVendors: true
    };
  },
  methods: {
    isEmpty(str) {
      return !str || str.length === 0;
    },
    remove(array, element) {
      const index = array.indexOf(element);
      if (index > -1) array.splice(index, 1);
    },
    regroupAllowed(covg) {
      return (
        covg.id === null ||
        (this.selectedClient && this.selectedClient.name === covg.clientName)
      );
    },
    loadVendorGroup() {
      this.loadingGroups = true;

      let idData, apiUrl;

      if (this.signupCode) {
        idData = this.signupCode;
        apiUrl = covgBySignupCodeAPI;
      } else if (this.covgId) {
        idData = this.covgId;
        apiUrl = covgByIdAPI;
      } else if (this.covId) {
        idData = this.covId;
        apiUrl = covgByCovIdAPI;
      } else {
        idData = this.ptid;
        apiUrl = covgByPtidAPI;
      }

      this.loadAllVendorGroups(idData.split(/[ ,]+/), apiUrl);
    },
    loadAllVendorGroups(idArray, apiUrl) {
      return Promise.all(
        idArray.map(idDatum => {
          let pathVar;
          if (apiUrl === covgBySignupCodeAPI) {
            pathVar = { code: idDatum };
          } else if (apiUrl === covgByIdAPI) {
            pathVar = { covgId: idDatum };
          } else if (apiUrl === covgByCovIdAPI) {
            pathVar = { covId: idDatum };
          } else {
            pathVar = { ptid: idDatum };
          }

          return get(apiUrl.getUrl(pathVar))
            .then(response => {
              if (response && response.data) {
                let covgs = response.data;
                if (!Array.isArray(covgs)) {
                  covgs = [covgs];
                }
                for (let covg of covgs) {
                  if (!this.vendorGroups.some(el => el.id === covg.id)) {
                    this.vendorGroups.push(covg);
                    if (this.regroupMode) {
                      this.vendorGroupsRestorePoint.push(covg);
                    }
                  }
                }
              }
            })
            .catch(err => {
              this.showMessage({
                text: "Unable to find vendor group",
                mode: "error"
              });
              console.log("Error loading vendor group: ", err);
            });
        })
      ).then(() => {
        this.signupCode = null;
        this.covgId = null;
        this.covId = null;
        this.ptid = null;
        this.loadingGroups = false;
      });
    },
    clearGroups() {
      this.vendorGroups.splice(0);
    },
    addNewGroup() {
      this.vendorGroups.unshift({
        id: null,
        preferredName: `New Group ${this.newGroupNumber}`,
        covs: []
      });
      this.newGroupNumber++;
    },
    enableRegrouping() {
      if (!this.regroupMode) {
        this.regroupMode = true;
        this.vendorGroupsRestorePoint = cloneDeep(this.vendorGroups);
        get(currentClientAPI.getUrl()).then(response => {
          this.selectedClient = response.data;
        });
      }
    },
    cancelRegrouper() {
      this.regroupMode = false;
      this.vendorGroups = cloneDeep(this.vendorGroupsRestorePoint);
      this.vendorGroupsRestorePoint.splice(0);
      this.newGroupNumber = 1;
    },
    cancelRegroup() {
      this.confirmationDialogOpen = false;
    },
    confirmRegroup() {
      this.regroupingOverlay = true;
      post(regroupCovgsAPI, { covgs: this.vendorGroups }).then(response => {
        if (response && response.data) {
          this.vendorGroups = response.data.affectedCovgs;
          let movedCovs = response.data.covsThatMoved;
          let errCovs = response.data.covsThatCouldNotMove;
          if (movedCovs.length === 0 && errCovs.length === 0) {
            this.showMessage({
              text: "No changes were made",
              mode: "info"
            });
          } else if (movedCovs.length > 0 && errCovs.length > 1) {
            let movedEs = movedCovs.length > 1 ? "s" : "";
            let errEs = errCovs.length > 1 ? "s" : "";
            let idString = errCovs.map(cov => cov.id).join(", ");
            this.showMessage({
              text: `Successfully moved ${movedCovs.length} COV${movedEs}.
                ${errCovs.length} COV${errEs} could not be moved: ${idString}`,
              mode: "warning"
            });
          } else if (movedCovs.length > 0) {
            let es = movedCovs.length > 1 ? "s" : "";
            this.showMessage({
              text: `Successfully moved ${movedCovs.length} COV${es}`,
              mode: "success"
            });
          } else if (errCovs.length > 0) {
            let idString = errCovs.map(cov => cov.id).join(", ");
            let es = errCovs.length > 1 ? "s" : "";
            this.showMessage({
              text: `${errCovs.length} COV${es} could not be moved: ${idString}`,
              mode: "error"
            });
          }
        }
        this.confirmationDialogOpen = false;
        this.regroupMode = false;
        this.vendorGroupsRestorePoint.splice(0);
        this.newGroupNumber = 1;
        this.regroupingOverlay = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.group-loader-card {
  .v-input {
    max-width: 120px;
  }
}

.noregroup {
  opacity: 0.3;
}

.movable {
  cursor: move;
}
</style>
